<template lang="pug">
div.wrap-item-object-list
  div(v-if="objects[0]"
    v-for="object in objects"
    @click="setTargetObjectByObjectDocId(object)").wrap-object-item.f.fm.flex-between.px12.py8.cursor-pointer
    div.f.fm
      div.wrap-main-img.f.fh.mr12
        img(:src="getAssetById(object.assetId).mainImg").object-fit-cover
        div(v-if="showObjectLoading(object)").wrap-object-loading.f.fh
          v-progress-circular(size="20" width="2"
            :color="pallete.$primary_bg_color" indeterminate)
      span.fz12.line-clamp-1 {{getAssetById(object.assetId).name}}
    div(v-if="!showObjectLoading(object)").wrap-actions.f.fm.ml12
      v-icon(@click.stop="setObjectInvisible(object)"
        size="16" dark).mr4 {{(object.isInvisible) ? 'mdi-eye-off' : 'mdi-eye'}}
      v-icon(@click.stop="setObjectLocked(object)"
        size="16" dark).pb4 {{(object.isLocked) ? 'mdi-lock' : 'mdi-lock-open-variant'}}
  div(v-if="!objects[0]").wrap-no-objects.f.fh
    span(v-if="isInitialized").block.text-center.fz12 オブジェクトがありません
    v-progress-circular(v-else size="20" width="2" indeterminate)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$asset_main_img_size: 32px;
.wrap-item-object-list {
  color: $dark_primary_text_color;
  width: 80vw; height: 100%;
  max-width: $studio_window_max_width; max-height: 80vh;
  overflow: scroll;
  .wrap-object-item {
    border-bottom: solid 0.8px rgba(240, 221, 221, 0.4);
    .wrap-main-img {
      position: relative;
      width: $asset_main_img_size; height: $asset_main_img_size;
      border-radius: 3px;
      overflow: hidden;
      background: $primary_bg_color;
      img {
        height: 100%;
      }
      .wrap-object-loading {
        position: absolute;
        width: 100%; height: 100%;
        background: $overlay_color;
      }
    }
  }
  .wrap-no-objects {
    height: 48px;
    span {
      color: $dark_primary_text_color;
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    objects: {
      type: Array,
      required: true
    },
    assets: {
      type: Array,
      required: true
    },
    loadingStatusesInObjectList: {
      type: Array,
      required: true
    },
    isInitialized: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    getAssetById (assetId) {
      return this.assets.filter(a => a.id === assetId)[0]
    },
    setTargetObjectByObjectDocId (object) {
      this.$emit('setTargetObjectByObjectDocId', object.id)
    },
    setObjectInvisible (object) {
      this.$emit('setObjectInvisible', {
        objectDocId: object.id, isInvisible: !object.isInvisible
      })
    },
    setObjectLocked (object) {
      this.$emit('setObjectLocked', {
        objectDocId: object.id, isLocked: !object.isLocked
      })
    },
    showObjectLoading (object) {
      const target = this.loadingStatusesInObjectList.filter(l => {
        return l.objectDocId === object.id
      })[0]
      // 新規追加された時はtargetにない
      return target ? target.isLoading : false
    }
  }
}
</script>
